import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Sculpting - Intrude",
  "use": "Sculpting - Intrude-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"Sculpting - Intrude\">\n  <rect id=\"Sculpting - Intrude_Rectangle_163575\" data-name=\"Rectangle 163575\" width=\"36\" height=\"36\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol